import { useMutation } from '@tanstack/react-query';
import {
  ReferralProgramService,
  CreateReferralProgramDto,
  GetReferralProgramEntity,
} from 'services/openapi';

export const useCreateReferralDetailMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<GetReferralProgramEntity, Error, CreateReferralProgramDto>({
      mutationFn: (variables: CreateReferralProgramDto) => {
        return ReferralProgramService.referralProgramControllerCreateReferralProgram(
          variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
